var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item"},[_c('span',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.displayValue(_vm.item.name))+" ")]),_c('span',{staticClass:"value"},[_vm._v(" "+_vm._s(_vm.displayValue(_vm.item.value))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }